import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setInitialised, setData, setBasepath, setError, setCountries } from 'src/redux/app/actions';
import Loader from 'components/_utility/Loader/Loader';
import request from 'helpers/request';
import { initialisedSelector } from 'src/redux/app/selectors';
import { getLanguageCode } from 'helpers/utilities';

const Init = ({ basepath, children }) => {
  const initialised = useSelector(initialisedSelector);
  const dispatch = useDispatch();
  const rootEl = document.getElementById('dealer-locator-root');
  const contentDataSourceId = rootEl.dataset.datasourceid;

  useEffect(() => {
    dispatch(setBasepath(basepath));

    const fetchData = async () => {
      try {
        const contentRes = await request(
          `/api/v2/places/searchresultscontent?DataSourceId=${contentDataSourceId}&SiteLanguageCode=${getLanguageCode()}`
        );

        const countriesRes = await request('/api/v2/places/countries');

        dispatch(setData(contentRes.data));
        dispatch(setCountries(countriesRes.data));
        dispatch(setInitialised());
      } catch (ex) {
        dispatch(setError(ex));
      }
    };

    fetchData();
  }, []);

  if (!initialised) {
    return <Loader />;
  }

  return children;
};

export default Init;
